import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, HomeIcon, KeyIcon } from 'lucide-react';
interface SelectViewingTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: 'inchiriere' | 'vanzare') => void;
}
export function SelectViewingTypeModal({
  isOpen,
  onClose,
  onSelectType
}: SelectViewingTypeModalProps) {
  return <AnimatePresence data-id="element-5518">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-5519" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-5520">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" data-id="element-5521">
              {/* Header */}
              <div className="bg-gradient-to-r from-[#132C53] to-[#1e4278] text-white px-6 py-5 flex items-center justify-between" data-id="element-5522">
                <div data-id="element-5523">
                  <h3 className="text-xl font-bold" data-id="element-5524">
                    Selectează Tip Vizionare
                  </h3>
                  <p className="text-sm text-blue-200" data-id="element-5525">
                    Alege tipul de tranzacție
                  </p>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-lg transition-colors" data-id="element-5526">
                  <XIcon className="w-6 h-6" data-id="element-5527" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4" data-id="element-5528">
                {/* Închiriere Option */}
                <button onClick={() => onSelectType('inchiriere')} className="w-full p-6 rounded-xl border-2 border-blue-200 hover:border-blue-500 hover:bg-blue-50 transition-all group" data-id="element-5529">
                  <div className="flex items-center space-x-4" data-id="element-5530">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-5531">
                      <KeyIcon className="w-8 h-8 text-white" data-id="element-5532" />
                    </div>
                    <div className="flex-1 text-left" data-id="element-5533">
                      <h4 className="text-lg font-bold text-[#132C53] mb-1" data-id="element-5534">
                        Închiriere
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-5535">
                        Vizionare pentru contract de închiriere
                      </p>
                    </div>
                  </div>
                </button>

                {/* Vânzare Option */}
                <button onClick={() => onSelectType('vanzare')} className="w-full p-6 rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:bg-emerald-50 transition-all group opacity-50 cursor-not-allowed" disabled data-id="element-5536">
                  <div className="flex items-center space-x-4" data-id="element-5537">
                    <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-5538">
                      <HomeIcon className="w-8 h-8 text-white" data-id="element-5539" />
                    </div>
                    <div className="flex-1 text-left" data-id="element-5540">
                      <h4 className="text-lg font-bold text-[#132C53] mb-1" data-id="element-5541">
                        Vânzare
                      </h4>
                      <p className="text-sm text-slate-600" data-id="element-5542">
                        Vizionare pentru contract de vânzare (în curând)
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}